const uniqBy = require('lodash/uniqBy')

function getFields(mapping) {
  const fields = []
  if (!mapping) return fields
  if (mapping.children) {
    mapping.children.forEach(c => {
      if (c.children) {
        const fieldPath = c.children && c.children.find(k => k.key === 'fieldPath')
        const q = c.children && c.children.find(k => k.key === 'queryable')
        const queryable = q && q.value === true
        const sobjectAPIName =
          c.children && c.children.find(k => k.key === 'sobjectAPIName')
        if (queryable && fieldPath) { fields.push({ fieldPath: fieldPath.value, sobjectAPIName }) }
      }
      if (c.value) {
        const { fieldPath, sobjectAPIName, queryable } = c.value
        if (queryable === true) fields.push({ fieldPath, sobjectAPIName })
      }
    })
  } else if (Array.isArray(mapping.value)) {
    mapping.value.forEach(({ fieldPath, sobjectAPIName, queryable }) => {
      if (queryable === true) {
        fields.push({ fieldPath, sobjectAPIName })
      }
    })
  }
  return fields
}

function getWhereQueryFields(where) {
  return where.rules?.filter(r => r.leftField)
                     .map(r => r.leftField || (r.fieldPath && r))
}

function getTransformationQueryFields(tr, excludeFields = false) {
  const isGroupBy = tr.groupBy?.groupByFields?.length !== 0
  return uniqBy(
    [
      ...(((!isGroupBy || excludeFields) && getWhereQueryFields(tr.where)) || []),
      ...(tr.groupBy?.groupByFields || []),
      ...(tr.groupBy?.aggregateFields?.filter(f => f?.fieldPath !== '') || [])
    ],
    'fieldPath'
  )
}

function getTransformationFieldSets(dataTransformer) {
  const deps = {}
  for(const r of dataTransformer?.where?.rules || []) {
    const dsfs = dataSourcesFieldSets(r.rightValue)
    for(const k of Object.keys(dsfs)) {
      if(r.rightValue.dataSource) {
        const id = typeof r.rightValue.dataSource === 'string' ? r.rightValue.dataSource : r.rightValue.dataSource.id
        deps[id] = [
          ...deps[id] || [],
          ...dsfs[k]
        ]
      }
    }
    
    if (r.leftField?.dataSourceId && r.leftField.fieldPath) {
      deps[r.leftField.dataSourceId] = deps[r.leftField.dataSourceId] || []
      deps[r.leftField.dataSourceId].push({ fieldPath: r.leftField.fieldPath, sobjectAPIName: r.leftField.sobjectAPIName })
    }
  }
  return deps
}

// this function is for determining which datasources need to be queried at load
// so we're not including function bindings
function dataSourcesFieldSets (m, dsfs = {}) {
  if (m.children) {
    for (const c of m.children) dataSourcesFieldSets(c, dsfs)
  }
  if (m.dataSource && (m.bindingType === 'data' || m.bindingType === 'value')) {
    const id = m.dataSource && (typeof m.dataSource === 'string' ? m.dataSource : m.dataSource.id)
    dsfs[id] = dsfs[id] || []
    if (m.value && m.value.fieldPath) {
      dsfs[id].push(m.value)
    } else if (m.value && m.value.forEach) {
      m.value.forEach(v => {
        if (v && v.fieldPath) dsfs[id].push(v)
      })
    }
    if (m.value && m.value.displayAs) {
      m.value.displayAs.value &&
        dsfs[id].push({
          ...m.value,
          fieldPath: m.value.displayAs.value
        })
      m.value.displayAs.label &&
        dsfs[id].push({
          ...m.value,
          fieldPath: m.value.displayAs.label
        })
    }
    if (m.type === 'FieldSet') {
      dsfs[id] = [
        ...dsfs[id],
        ...getFields(m)
      ]
    }
    /* if (m.dataTransformer) {
     *   const trFS = getTransformationFieldSets(m.dataTransformer)
     *   Object.keys(trFS).forEach(k => {
     *     dsfs[k] = dsfs[k] || []
     *     dsfs[k] = dsfs[k].concat(trFS[k])
     *   })
     *   dsfs[id] = [
     *     ...dsfs[id],
     *     ...getTransformationQueryFields(m.dataTransformer)
     *   ]
     * }     */
    if (m.value && m.value.referenceData) {
      const refData = Array.prototype.concat(m.value.referenceData).filter(r => r.dataSourceId)
      for (const rd of refData) {
        dsfs[rd.dataSourceId] = [...dsfs[rd.dataSourceId] || []]
      }
    }
  }

  if (
    m.type === 'Transformation'
  ) {
    const trFS = getTransformationFieldSets(m.value)
    Object.keys(trFS).forEach(k => {
      dsfs[k] = dsfs[k] || []
      dsfs[k] = dsfs[k].concat(trFS[k])
    })
  }
  return dsfs
}

module.exports = {
  getFields,
  getTransformationQueryFields,
  getWhereQueryFields,
  getTransformationFieldSets,
  dataSourcesFieldSets
}
